import { PackageCatalogSection } from "./PackageCatalogSection";
import { PackageDiscountSection } from "./PackageDiscountSection";
import { PackageImageField } from "./PackageImageField";
import { PackageItemsSection } from "./PackageItemsSection";
import { PackagePriceSummary } from "./PackagePriceSummary";
import { PackageShippingSection } from "./PackageShippingSection";
import { PackageTranslationsSection } from "./PackageTranslationsSection";
import { usePackagePreview } from "../usePackagePreview";

export interface PackageFormBodyProps {
  /** `true` al editar: bloquea el slug. */
  locked: boolean;
}

/**
 * Los bloques del formulario, en el orden en que se decide un paquete.
 *
 * Qué es → dónde vive → qué lleva → cuánto se le quita → cuánto queda →
 * cuánto pesa y mide → cómo se ve. El bloque calculado va JUSTO detrás del descuento, no al
 * final: es la respuesta a lo que se acaba de teclear, y a media
 * pantalla de distancia habría que recordar el porcentaje mientras se
 * busca la cifra.
 *
 * Una sola página con secciones y no un wizard como el del producto. El
 * producto tiene cuarenta y cinco campos y por eso se reparte en diez
 * pasos; el paquete tiene nueve, y partirlos en pasos escondería el
 * precio calculado detrás de un botón "Siguiente" — que es justo lo que
 * este formulario existe para no hacer.
 *
 * `usePackagePreview` se llama UNA vez, aquí, y el resultado baja a los
 * dos bloques que lo necesitan. Llamarlo en cada uno pediría el catálogo
 * dos veces y, peor, dejaría dos cuentas que pueden divergir.
 */
export function PackageFormBody({ locked }: PackageFormBodyProps) {
  const state = usePackagePreview();

  return (
    <>
      <PackageTranslationsSection />
      <PackageCatalogSection locked={locked} />
      <PackageItemsSection state={state} />
      <PackageDiscountSection />
      <PackagePriceSummary state={state} />
      <PackageShippingSection state={state} />
      <PackageImageField />
    </>
  );
}
